module.exports = __webpack_public_path__ + "static/img/EvaluationListleyi.c2b0b993.png";